import { render, staticRenderFns } from "./eightLogoRow.vue?vue&type=template&id=65f22493&"
import script from "./eightLogoRow.vue?vue&type=script&lang=js&"
export * from "./eightLogoRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports